module.exports = {
  selectLanguage: 'Select your language',
  greeting: 'Howdy',
  categories: 'Categories',
  contact: 'Contact',
  readTime: '{time} Min Read',
  blog: 'Blog',
  docs: 'Docs',
  mainPage: 'Home',
  copyrights: '@SerializedOwen 2020. All rights reserved.',
  login: 'Login',
  logout: 'Logout',
  account: 'Account',
  delete: 'Delete',
  yes: 'Yes',
  no: 'No',
  tools: 'Tools',
  checkInBanner: 'You have checked in for {days} days in a row!',
  'nginx-regex-tester': 'Nginx Regex Tester',
  saving: 'Saving',
  saved: 'Saved',
  waiting: 'Waiting for finish typing',
  'markdown-editor': 'Markdown',
  public: 'Public',
  private: 'Private',
  visibility: 'Visibility',
  title: 'Title'
}
